/* A vote row with its thumbs at the end of the line, outside the <label>. */
.ratedRow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: var(--tuna-spacing-1);
}

/*
 * While voting, the row under the pointer (or holding keyboard focus) is tinted end to end, so it is clear which
 * thumbs and comment button belong to which option.
 */
.interactive {
  padding-inline: var(--tuna-spacing-1);
  border-radius: var(--tuna-shape-radius-sm);
}

.interactive:focus-within {
  background-color: var(--tuna-palette-action-selected);
}

@media (hover: hover) {
  .interactive:hover {
    background-color: var(--tuna-palette-action-selected);
  }
}

@media (prefers-reduced-motion: no-preference) {
  .interactive {
    transition: background-color 100ms ease-out;
  }
}

/* The vote views give their labels `width: 100%`, which would push the thumbs off the line. */
.ratedRow > :first-child {
  flex: 1 1 0;
  min-width: 0;
}

.ratedRow > label:first-child {
  width: auto;
}

.rating {
  display: flex;
  flex-shrink: 0;
}

.idle {
  color: var(--tuna-content-secondary);
}

.up {
  color: var(--tuna-palette-success-main);
}

.down {
  color: var(--tuna-palette-error-main);
}

@media (prefers-reduced-motion: no-preference) {
  .idle,
  .up,
  .down {
    transition: color 150ms ease-out;
  }
}

/* The voter's comment: its own line under the option. */
.comment {
  flex-basis: 100%;
  margin-bottom: var(--tuna-spacing-1);
}

/* The rows' offset parent, so the reorder animation measures every row against the same origin. */
.rows {
  position: relative;
  display: flex;
  flex-direction: column;
}
